<template>
    <div
        class="w-full pt-24"
        v-if="articles && articles.length"
    >
        <h3 class="text-slate-800 dark:text-slate-100 text-3xl font-medium leading-9">
            Program featured articles
        </h3>
        <div class="block md:hidden">
            <div
                data-horizontal-scroll
                class="pt-6 -ml-4 -mr-8 md:-mx-4 px-4 overflow-x-auto hide-scrollbar scroll-smooth touch-pan-x overscroll-x-contain"
                @dragstart.prevent
            >
                <div
                    class="flex items-start gap-6 flex-nowrap snap-x snap-proximity"
                >
                    <a
                        v-for="article in articles"
                        :key="article.id"
                        class="group flex flex-col w-[80%] flex-shrink-0 snap-start select-none"
                        :href="article.url"
                        target="_blank"
                        rel="noopener noreferrer"
                        draggable="false"
                        style="
                            touch-action: pan-x;
                            -webkit-user-drag: none;
                        "
                    >
                        <div
                            class="flex w-full aspect-[79/50] justify-center items-center self-stretch rounded-lg bg-slate-200 dark:bg-slate-700 mb-3 overflow-hidden p-2"
                        >
                            <img
                                v-if="article.image"
                                :src="article.image"
                                :alt="article.title"
                                draggable="false"
                                class="w-full h-full object-contain object-center pointer-events-none select-none"
                            />
                            <div
                                v-else
                                class="w-full h-full grid place-items-center text-slate-500 dark:text-slate-400 text-sm"
                            >
                                No image
                            </div>
                        </div>

                        <div
                            class="flex flex-col items-start gap-2 self-stretch"
                        >
                            <div
                                class="flex flex-col items-start gap-1 self-stretch"
                            >
                                <h4
                                    class="text-slate-800 dark:text-slate-100 text-base font-medium leading-6 transition-colors duration-200 group-hover:text-slate-600 dark:group-hover:text-slate-300"
                                >
                                    {{ article.title }}
                                </h4>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>

        <div class="hidden md:block relative">
            <div class="overflow-hidden">
                <div
                    ref="carouselContainer"
                    class="flex items-start gap-6 pt-6 transition-transform duration-300 ease-in-out"
                    :style="{
                        transform: `translateX(-${currentSlide * 264}px)`,
                    }"
                >
                    <a
                        v-for="article in articles"
                        :key="article.id + '-desktop'"
                        class="group flex flex-col w-[240px] flex-shrink-0"
                        :href="article.url"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <div
                            class="flex h-[132px] min-h-[132px] max-h-[132px] w-full justify-center items-center self-stretch rounded-lg bg-slate-200 dark:bg-slate-700 mb-3 overflow-hidden p-2"
                        >
                            <img
                                v-if="article.image"
                                :src="article.image"
                                :alt="article.title"
                                class="w-full h-full object-contain object-center"
                            />
                            <div
                                v-else
                                class="w-full h-full grid place-items-center text-slate-500 dark:text-slate-400 text-sm"
                            >
                                No image
                            </div>
                        </div>

                        <div
                            class="flex flex-col items-start gap-2 self-stretch"
                        >
                            <div
                                class="flex flex-col items-start gap-1 self-stretch"
                            >
                                <h4
                                    class="text-slate-800 dark:text-slate-100 text-base font-medium leading-6 transition-colors duration-200 group-hover:text-slate-600 dark:group-hover:text-slate-300"
                                >
                                    {{ article.title }}
                                </h4>
                            </div>
                        </div>
                    </a>
                </div>
            </div>

            <div
                v-if="articles && articles.length > visibleCount"
                class="absolute right-0 top-24 transform -translate-y-1/2"
            >
                <button
                    @click="nextSlide"
                    class="inline-flex p-2.5 items-start gap-2.5 rounded-full bg-white dark:bg-slate-800 shadow-sm border border-slate-200 dark:border-slate-700 hover:shadow-md transition-shadow duration-200"
                >
                    <Icon
                        icon="chevron-right"
                        class="w-5 h-5 text-slate-600 dark:text-slate-300"
                    />
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import Icon from '@/components/ui/icon/icon.vue';

const props = defineProps({
    articles: Array,
});

const visibleCount = 4;
const currentSlide = ref(0);
const maxSlides = computed(() =>
    Math.max((props.articles?.length || 0) - visibleCount, 0)
);

watch(
    () => props.articles?.length,
    () => {
        currentSlide.value = 0;
    }
);

const nextSlide = () => {
    if (currentSlide.value < maxSlides.value) {
        currentSlide.value++;
    } else {
        currentSlide.value = 0;
    }
};
</script>
